import { CMS_CONFIG } from '../config/cms.config';

const addProductInfoProps = ({ langUuid, form }) => {
	const productInfoProps = {};
	CMS_CONFIG.PRODUCT_INFO.forEach((productInfo) => {
		productInfoProps[productInfo.key] = form[`${langUuid}-${productInfo.key}`];
	});
	return productInfoProps;
};

export default addProductInfoProps;



// WEBPACK FOOTER //
// ./src/helpers/addProductInfoProps.js